import { cx } from '@/utils';
import CustomLink from '@common/CustomLink';

import { QuickAccessContent } from './QuickAccessContent';
import { QuickAccessIcon } from './QuickAccessIcon';

export interface QuickAccessItemProps {
  linkItem: any;
  image: any;
  quickAccessName?: string;
  description?: string;
}

interface QuickAccessCardProps {
  item: QuickAccessItemProps;
  variant?: 'vertical' | 'horizontal';
  className?: string;
}

export const QuickAccessCard = ({
  item,
  variant = 'vertical',
  className,
}: QuickAccessCardProps) => {
  const isVertical = variant === 'vertical';

  const baseClasses =
    'flex items-center rounded-xl bg-white border-blueLight border-[1px] opacity-100 shadow-md transition-opacity duration-150 hover:opacity-80';

  const variantClasses = isVertical
    ? 'h-[180px] flex-col justify-start gap-2 pb-4 pl-[18px] pr-[18px] pt-4'
    : 'h-[107px] flex-row items-start justify-center gap-[22px] px-[24px] pb-4 pt-4';

  return (
    <CustomLink className={cx(baseClasses, variantClasses, className)} pageLink={item.linkItem}>
      <QuickAccessIcon image={item?.image} height={57} width={57} />
      <QuickAccessContent
        title={item.quickAccessName}
        description={item.description}
        titleClassName={
          isVertical
            ? 'line-clamp-2 overflow-hidden text-center text-[20px] font-bold text-primaryDark' // Modified slightly to match A style
            : 'line-clamp-2 overflow-hidden text-left text-[18px] font-bold text-primaryDark' // Default fallback
        }
        descriptionClassName={
          isVertical
            ? 'line-clamp-3 min-w-[243px] flex-1 text-center text-sm leading-tight text-tundora'
            : 'line-clamp-3 text-[14px] leading-[15px] text-tundora'
        }
        containerClassName={
          isVertical
            ? 'flex flex-col gap-[3px]'
            : 'flex w-[168px] flex-1 flex-col gap-[3px] self-center'
        }
      />
    </CustomLink>
  );
};
